import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import ActionRenderer from '../../GridRenderer/actionRendere'
import {
  calculateGridHeight,
  showNotification,
  customComparator,
} from '@/services/calculate'
import CheckboxRender from '@/components/DynamicComponents/Renderers/checkboxRender'
import Pagination from '@/components/DynamicComponents/Pagination'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import exportTemplates from '@/components/DynamicComponents/exportTemplates'
import importTemplates from '@/components/DynamicComponents/importTemplates'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import { createRequest, tableName } from '@/services/config'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    Pagination,
    importTemplates,
    exportTemplates,
  },
  props: {
    tabKey: String,
    isAddContract: Boolean,
    type: String,
    columnSettings: Array,
    screenId: Number,
    isArchive: Boolean,
  },
  data: function () {
    const checkLength = (rule, value, callback) => {
      if (rule.field === 'contract') {
        const reg = /^(?!$)\d{0,8}(?:\.\d{1,2})?$/
        if (!reg.test(value)) {
          callback(
            new Error('Please enter valid contract # (For e.g.:  12345678.12)'),
          )
        } else {
          callback()
        }
      } else {
        if (String(value).length > 100) {
          callback(
            new Error('Contract must be less than or equals to 100 characters'),
          )
        } else {
          callback()
        }
      }
    }
    return {
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      loading: true,
      spinner: false,
      defaultSortedBy: 'contract',
      defaultSortOrder: true,
      page: 0,
      pageSize: 0,
      contractList: [],
      visible: false,
      modalTitle: '',
      form: {
        id: undefined,
        contract: undefined,
        contractName: undefined,
        isActive: 1,
      },
      rules: {
        contract: [
          {
            required: true,
            message: 'Please enter contract #',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
        contractName: [
          { required: true, message: 'Please enter contract', trigger: 'blur' },
          { validator: checkLength, trigger: 'blur' },
        ],
      },
      selectedRowKeys: [],
      loadRefresh: false,
      // gridOptions: null,
      // columnDefs: null,
      defaultColDef: null,
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      height: '400px',
      filters: {},
      exportClicked: false,
      uploadedFile: null,
      importClicked: false,
      importColDef: [
        {
          checkboxSelection: this.checkboxSelection,
          headerCheckboxSelection: this.headerCheckboxSelection,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Contract #',
          field: 'Contract',
          width: 120,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Contract',
          field: 'ContractName',
          tooltipField: 'ContractName',
          width: 250,
        },
      ],
      loadImport: false,
      updateRequest: null,
      requestKeys: ['contract', 'contractName', 'isActive'],
      gridOptions: {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        rowSelection: 'multiple',
        tooltipShowDelay: 0,
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      },
      columnDefs: [
        {
          field: 'checkbox',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 60,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Contract #',
          field: 'contract',
          width: 100,
          sort: 'asc',
          filter: 'customFilter',
          headerTooltip: 'Contract #',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
        },
        {
          headerName: 'Contract',
          field: 'contractName',
          width: 370,
          filter: 'customFilter',
          headerTooltip: 'Contract',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { filter: 'dynamic' },
          comparator: customComparator,
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'Contract',
            edit: true,
            delete: true,
          },
          pinned: 'right',
          menuTabs: [],
        },
      ],
    }
  },
  beforeMount() {
    if (this.isAddContract) {
      this.addNew()
    }
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    this.loadingConfig()
  },
  mounted() {
    this.$root.$on('deleteContract', this.deleteContract)
    this.$root.$on('editContract', this.getContractById)
    window.addEventListener('resize', this.getWindowSize)
  },
  watch: {
    tabKey() {
      if (this.tabKey === '14') {
        this.filters = {}
        const data = this.gridOptions.api.getFilterModel()
        Object.keys(data).forEach(element => {
          const filterComponent = this.gridOptions.api.getFilterInstance(
            element,
          )
          filterComponent.setModel(null)
        })
        this.contractList = []
        this.loading = true
        this.defaultSortedBy = 'contract'
        this.defaultSortOrder = true
        // this.gridOptions.columnApi.applyColumnState({
        //   state: [
        //     {
        //       colId: 'contract',
        //       sort: 'asc',
        //     },
        //   ],
        //   defaultState: { sort: null },
        // })
        this.getContracts(this.tableParams)
      }
    },
  },
  beforeDestroy() {
    this.$root.$off('editContract')
    this.$root.$off('deleteContract')
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    loadingConfig() {
      this.gridOptions.isRowSelectable = node => {
        if (node.data) {
          if (node.data.isLinked || node.data.applicationId) return false
          else return true
        }
      }
      this.frameworkComponents = {
        actionCellRenderer: ActionRenderer,
        checkboxCellRender: CheckboxRender,
        customFilter: CustomFilter,
        toolTipRenderer: ToolTipRenderer,
      }
    },

    // Refresh Contracts
    refreshContracts() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.loadRefresh = true
      this.contractList = []
      this.page = 0
      this.defaultSortedBy = 'contract'
      this.defaultSortOrder = true
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'contract',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.selectedRowKeys = []
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getContracts(this.tableParams)
    },

    // Close the dialog
    handleCancel() {
      this.visible = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
      if (this.isAddContract) {
        this.$emit('addContract', null, false)
      }
    },

    // Add New Contract
    addNew() {
      this.visible = true
      this.modalTitle = 'Add New Contract'
      this.form.contract = undefined
      this.form.id = null
      this.form.contractName = null
      this.form.isActive = 1
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Save Contract
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.form.id) {
            this.updateContract()
          } else {
            this.addContract()
          }
        }
      })
    },

    // Load Contracts
    getContracts(params, type) {
      if (!this.isAddContract) {
        const req = {
          pageSize: this.pageSize,
          currentPage: this.page,
          sortColumn: this.defaultSortedBy,
          isAscending: this.defaultSortOrder,
          contract: _.get(this.filters, 'contract', undefined),
          contractName: _.get(this.filters, 'contractName', undefined),
        }
        instance
          .post(projectAPIs.master.contract.list(this.$route.params.id), req)
          .then(response => {
            this.contractList = _.get(response.data, 'result', [])
            this.count = _.get(response.data, 'totalCount', 0)
            this.height = calculateGridHeight(
              'contractTable',
              this.count > this.pageSize,
            )
            this.loading = false
            this.loadRefresh = false
            if (type === 'sort') {
              this.updateColumnSetting()
            } else {
              this.getColumnSettings(params)
            }
          })
          .catch(error => {
            this.loading = false
            this.loadRefresh = false
            errorService(error)
          })
      }
    },

    // Get Contract By Id
    getContractById(id, record) {
      this.visible = true
      this.modalTitle = 'Edit'
      this.spinner = true
      instance
        .get(projectAPIs.master.contract.details(this.$route.params.id, id))
        .then(response => {
          this.form.id = _.get(response.data, 'result.id', null)
          this.form.contract = _.get(response.data, 'result.contract', null)
          this.form.contractName = _.get(
            response.data,
            'result.contractName',
            null,
          )
          this.form.isActive = _.get(
            response.data,
            'result.isActive',
            record.isActive,
          )
          this.updateRequest = _.get(response.data, 'result', null)
          this.spinner = false
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    confirmDelete(record) {
      this.loading = true
      const req = record ? [record.id] : this.selectedRowKeys
      instance
        .delete(projectAPIs.master.contract.delete(this.$route.params.id), {
          data: req,
        })
        .then(response => {
          showNotification(
            'success',
            'Delete Contract',
            'Contract deleted successfully!',
          )
          this.refreshContracts()
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    // Delete All Contracts
    deleteAllType() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected contracts ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected
              contracts
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Delete Contract
    deleteContract(data) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete '${data.contract} - ${data.contractName}' ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to this contract
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(data)
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function (s) {
          return s.sort != null
        })
        .map(function (s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.contractList = []
      if (sortData.length > 0) {
        this.defaultSortedBy = sortData[0]['colId']
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'contract'
        this.defaultSortOrder = true
      }
      this.tableState = this.gridOptions.columnApi.getColumnState()
      this.getContracts(this.tableParams, 'sort')
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'contractTable',
        this.count > this.pageSize,
      )
      this.gridOptions.api.sizeColumnsToFit()
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.contractList = []
      this.selectedRowKeys = []
      this.getContracts(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.loading = true
      this.page = 0
      this.contractList = []
      this.getContracts(this.gridOptions)
    },

    // exportClicked
    downloadTemplate() {
      this.exportClicked = true
    },

    clickedCancel() {
      this.exportClicked = false
    },

    handleImport(event) {
      this.importClicked = true
      this.uploadedFile = event.file
      this.loadImport = true
    },

    beforeUpload(file) {
      const isValid =
        file.type === 'xlsx' ||
        file.type === 'xls' ||
        file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      if (!isValid) {
        showNotification('error', 'Import', 'Please upload excel file only!')
      }
      return isValid
    },

    updateTable() {
      this.importClicked = false
      this.refreshContracts()
    },

    clickedCancelimport(addedCount) {
      this.importClicked = false
      this.loadImport = false
      if (addedCount > 0) {
        this.refreshContracts()
      }
    },

    // Add contract
    addContract() {
      this.spinner = true
      instance
        .post(projectAPIs.master.contract.add(this.$route.params.id), {
          contract: this.form.contract,
          contractName: this.form.contractName,
        })
        .then(response => {
          this.spinner = false
          if (response.data.message) {
            showNotification('warning', 'Contract', response.data.message)
          } else {
            this.visible = false
            showNotification(
              'success',
              'Create Contract',
              'Contract created successfully!',
            )
            if (this.isAddContract) {
              this.$emit(
                'addContract',
                _.get(response.data, 'result', undefined),
                false,
              )
            } else {
              this.getContracts(this.tableParams)
            }
            this.$refs.ruleForm.resetFields()
          }
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    // Update contract
    updateContract() {
      const req = createRequest(
        this.requestKeys,
        this.updateRequest,
        this.form,
      )

      if (!req.isValid) {
        showNotification(
          'info',
          'Update Contract',
          'No changes found to update!',
        )
        return
      }
      this.spinner = true
      instance
        .patch(
          projectAPIs.master.contract.details(
            this.$route.params.id,
            this.form.id,
          ),
          req.request,
        )
        .then(response => {
          this.spinner = false
          if (response.data.message) {
            showNotification('warning', 'Contract', response.data.message)
          } else {
            this.visible = false
            showNotification(
              'success',
              'Update Contract',
              'Contract updated successfully!',
            )
            const newData = [...this.contractList]
            const index = newData.findIndex(i => i.id === this.form.id)
            newData[index]['contract'] = this.form.contract
            newData[index]['contractName'] = this.form.contractName
            this.contractList = newData
            this.$refs.ruleForm.resetFields()
          }
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    getColumnSettings(params) {
      const columnDetails = this.columnSettings.find(
        i =>
          i.screenId === this.screenId &&
          i.tableName === tableName.project.master.contract,
      )
      if (columnDetails && columnDetails.columnDetails) {
        const tableState = JSON.parse(columnDetails.columnDetails)
        this.gridOptions.columnApi.applyColumnState({
          state: tableState,
          applyOrder: true,
        })
      } else {
        if (params) {
          this.tableParams = null
          this.tableParams = params
          params.api.sizeColumnsToFit()
        }
      }
      params.columnApi.applyColumnState({
        state: [
          {
            colId: 'checkbox',
            hide: this.isArchive,
          },
          {
            colId: 'action',
            hide: this.isArchive,
          },
        ],
      })
      if (this.isArchive) {
        if (params) {
          this.tableParams = null
          this.tableParams = params
          params.api.sizeColumnsToFit()
        }
      }
    },

    updateColumnSetting() {
      const tableState = this.gridOptions.columnApi.getColumnState()
      const request = {
        screenId: this.screenId,
        tableName: tableName.project.master.contract,
        columnDetails: JSON.stringify(tableState),
      }
      if (!this.isArchive) {
        this.$emit('updateColumnSettings', request)
      }
    },

    onColumnResized(e) {
      if (e.finished) {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        this.updateColumnSetting()
      }
    },
  },
}
